import PropTypes from 'prop-types';
import LegacyConstituentCategories from '@/constants/constituents/LegacyConstituentCategories';
import LegacyConstituentRules from '@/constants/constituents/LegacyConstituentRules';
import SortOrder from '@/constants/SortOrder';
import { ConstituentType } from '@/lib/types/ConstituentPropType';

export const SortBy = Object.freeze({
  DISPLAY_NAME: 'display_name',
  LAST_INTERACTION_DATE: 'last_interaction_date',
});

const ConstituentFilterPropType = PropTypes.shape({
  userIds: PropTypes.string, // TODO(jon): Eventually this should support an array of IDs to match the API.
  displayName: PropTypes.string,
  sortBy: PropTypes.oneOf(Object.values(SortBy)),
  sortOrder: PropTypes.oneOf(Object.values(SortOrder)),
  constituentRules: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(LegacyConstituentRules)),
  ),
  constituentCategories: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(LegacyConstituentCategories)),
  ),
  constituentType: PropTypes.oneOf(Object.values(ConstituentType)),
});

export default ConstituentFilterPropType;
